export const PORTAL_TREE_VIEW_MENU_TYPE = {
  CONTEXT_MENU: 'CONTEXT_MENU',
  TITLE_MENU: 'TITLE_MENU',
} as const;

export type PORTAL_TREE_VIEW_MENU_TYPE = typeof PORTAL_TREE_VIEW_MENU_TYPE;
export type A_PORTAL_TREE_VIEW_MENU_TYPE = PORTAL_TREE_VIEW_MENU_TYPE[keyof PORTAL_TREE_VIEW_MENU_TYPE];
